import axios from 'axios';

export default {
    name: 'assets',
    data() {
        return {
            auth: this.$parent.auth,
            properties: [],
            selectedProperty: 0,
            selectedTab: 'location',
            areasList: [],
            areaTypes: [],
            categories: {},
            tabs: [
                { name: 'location', text: this.$t('HC_BY_LOCATION') },
                { name: 'category', text: this.$t('HC_BY_CATEGORY') }
            ],
            addCategoryModal: {
                showModal: false,
                name: '',
                nameStatus: '',
                nameMessage: '',
                description: ''
            },
            alert: {
                message: this.$t('HC_OOPS_SOMETHING_WENT_WRONG'),
                status: 'danger',
                icon: 'exclamation-circle-outline',
                isHidden: true
            }
        };
    },
    created() {
        this.selectedProperty = this.auth.user.selectedProperty.id;
        axios
            .get(this.auth.v4.url + '/properties?fields=id,name', {
                headers: {
                    'x-api-key': this.auth.v4.token
                }
            })
            .then(result => {
                result.data.forEach(property => {
                    // ensure primary property is at first index of properties array
                    if (property.id === this.auth.user.selectedProperty.id) {
                        this.properties.unshift({
                            label: property.name,
                            value: property.id
                        });
                        this.$parent.propertyName = property.name;
                    } else {
                        this.properties.push({
                            label: property.name,
                            value: property.id
                        });
                    }
                });
                this.selectTab('location');
            })
            .catch(() => this.$parent.showAlert());
    },
    methods: {
        selectTab(tab) {
            this.selectedTab = tab;
            if (tab === 'category') {
                this.getCategories(this.selectedProperty);
            } else {
                this.getAreasByLocation(this.selectedProperty);
            }
        },
        getCategories(property) {
            axios
                .get(
                    this.auth.v4.url +
                        `/item-categories?fields=name,example,assetCount&propertyId=${property}&orderBy=name`,
                    {
                        headers: {
                            'x-api-key': this.auth.v4.token
                        }
                    }
                )
                .then(result => {
                    this.categories = result.data.data;
                })
                .catch(() => {
                    this.alert = {
                        isHidden: false,
                        message: this.$t('HC_OOPS_SOMETHING_WENT_WRONG'),
                        status: 'danger',
                        icon: 'exclamation-circle-outline'
                    };
                });
        },
        getAreasByLocation(property) {
            axios
                .get(
                    this.auth.v4.url +
                        `/areas?propertyId=${property}&expand=type`,
                    {
                        headers: {
                            'x-api-key': this.auth.v4.token
                        }
                    }
                )
                .then(result => {
                    this.areasList = result.data.data.sort((a, b) => {
                        //get the areas list and sort by the area name
                        return a.name.localeCompare(b.name, undefined, {
                            numeric: true,
                            sensitivity: 'base'
                        });
                    });
                    this.areaTypes = Array.from([
                        // use the areas list to create an array of unique types
                        ...new Set(this.areasList.map(a => a.type.id))
                    ])
                        // using our new set loop through each and
                        //add the matching key: value pair for the type name
                        .map(id => {
                            return {
                                id: id,
                                name: this.areasList.find(a => a.type.id === id)
                                    .type.name
                            };
                        })
                        //sort areaTypes
                        .sort((a, b) => {
                            return a.id - b.id;
                        });
                })
                .catch(() => this.$parent.showAlert());
        },
        updateProperty(property) {
            this.selectedProperty = property;
            if (this.selectedTab === 'category') {
                this.getCategories(property);
            } else {
                this.getAreasByLocation(property);
            }
        },
        // click event for selecting a category
        selectCategory(category) {
            this.$emit('currentView', 'types');
            this.$emit('selectedCategory', category);
            this.$emit('categories', this.categories);
            this.$emit('property', {
                id: this.selectedProperty,
                name: this.properties.find(
                    x => x.value === this.selectedProperty
                ).label
            });
            this.$emit('currentTransition', 'component-slide-fade-up');
        },
        // User submits modal
        addCategory() {
            // Make sure that we aren't creating a duplicate cateogry name here
            for (let i = 0; i < this.categories.length; i++) {
                if (
                    this.addCategoryModal.name.toLowerCase() ==
                    this.categories[i].name.toLowerCase()
                ) {
                    this.addCategoryModal.nameStatus = 'status-error';
                    this.addCategoryModal.nameMessage = this.$t(
                        'HC_CATEGORY_ALREADY_EXISTS'
                    );
                    return false;
                }
            }

            let data = {
                propertyId: this.selectedProperty,
                name: this.addCategoryModal.name,
                example: this.addCategoryModal.description
            };

            axios
                .post(this.auth.v4.url + '/item-categories', data, {
                    headers: {
                        'x-api-key': this.auth.v4.token
                    }
                })
                .then(() => {
                    this.getCategories(this.selectedProperty);
                    this.closeAddCategoryModal();

                    this.alert = {
                        isHidden: false,
                        message: this.$t(
                            'HC_ASSET_CATEGORY_SUCCESSFULLY_ADDED'
                        ),
                        status: 'success',
                        icon: 'check-circle-outline'
                    };
                })
                .catch(() => {
                    this.closeAddCategoryModal();
                    this.alert = {
                        isHidden: false,
                        message: this.$t('HC_OOPS_SOMETHING_WENT_WRONG'),
                        status: 'danger',
                        icon: 'exclamation-circle-outline'
                    };
                });
        },
        closeAddCategoryModal() {
            this.addCategoryModal = {
                showModal: false,
                name: '',
                nameStatus: '',
                nameMessage: '',
                description: ''
            };
        },
        areasListFiltered(id) {
            return this.areasList.filter(a => a.type.id === id);
        },
        removeErrorMessage() {
            for (let i = 0; i < this.categories.length; i++) {
                if (
                    this.addCategoryModal.name.toLowerCase() !==
                    this.categories[i].name.toLowerCase()
                ) {
                    this.addCategoryModal.nameStatus = '';
                    this.addCategoryModal.nameMessage = '';
                }
            }
        }
    },
    computed: {
        isCompleted() {
            return this.addCategoryModal.name.length >= 2;
        }
    },
    watch: {
        selectedProperty(propertyId) {
            if (this.properties.length > 0) {
                this.$parent.propertyName = this.properties.find(
                    x => x.value == propertyId
                ).label;
            }
        }
    }
};
